var exports = {
  "bB": "strip__1egFBc",
  "Y3": "anchor__mtkpjk",
  "v9": "tourPortal__55uvAi",
  "LF": "stripButton___ogk_7",
};

module.exports = exports;
